import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Paper, Stack, styled,
    Typography
} from "@mui/material";
import {Download} from "@mui/icons-material";
import {DocxGenerator, HtmlGenerator} from "../Utils/MarkdownConvert";
import {EditIcon} from "lucide-react";
import {ProposalItem} from "../models/proposal/Proposal";
import {useNavigate} from "react-router-dom";

interface IDocumentViewerProps {
    proposalItem: ProposalItem;
    allowEdit?: boolean;
    allowDownload?: boolean;
}

const Item = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
}));

const DocumentViewer = ( { proposalItem, allowEdit, allowDownload }: IDocumentViewerProps ) => {
    const [text, setText] = useState("");
    const navigate = useNavigate();
    
    useEffect(() => {
        parseMarkdown().catch();
    }, [proposalItem]);
    
    const parseMarkdown = async () => {
        const html = await HtmlGenerator.convert(proposalItem.result);
        
        setText(html);
    }

    const handleDownload = async () => {
        await DocxGenerator.convert(proposalItem.result);
    };
    
    const handleEdit = () => {
        navigate("/proposals/edit", { state: proposalItem });
    };

    return (
        <>
            <Paper elevation={3} sx={{p: 3, bgcolor: "background.paper"}}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 3,
                    }}
                >
                    <img
                        src="/Logo.svg"
                        alt="Logo"
                        style={{height: "50px"}}
                    />
                    {(allowEdit || allowDownload) && (
                        <Stack>
                            {allowEdit && (
                                <Item>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<EditIcon/>}
                                        onClick={handleEdit}
                                    >
                                        Bewerken
                                    </Button>
                                </Item>)
                            }
                            {allowDownload && (
                                <Item>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<Download/>}
                                        onClick={handleDownload}
                                    >
                                        Download als Word
                                    </Button>
                                </Item>
                            )}
                        </Stack>
                    )}
                </Box>

                <Typography variant="h6" gutterBottom>
                    Voorgesteld besluit
                </Typography>
                <Typography variant="body1" paragraph>
                </Typography>
                <div dangerouslySetInnerHTML={{__html: text}}/>
            </Paper>
        </>
    );
}

export default DocumentViewer;